import { action, computed, makeObservable, observable } from 'mobx';
import { RootStore } from './index';
import { BaseStore } from './base.store';
import { UnsavedChanges } from 'src/utils/enums';

export class UnsavedChangesStore extends BaseStore {

    public unsavedChanges: Record<string, any> = {};

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            hasUnsavedChanges: computed,
            unsavedChanges: observable,
            setUnsavedChanges: action,
            deleteAllUnsavedChanges: action,
            deleteUnsavedChanges: action,
        });
    }

    get hasUnsavedChanges() {
        return !!Object.values(this.unsavedChanges).length;
    }

    public setUnsavedChanges = (key: UnsavedChanges) => {
        this.unsavedChanges = {
            ...this.unsavedChanges,
            [key]: true,
        };
    };

    public deleteAllUnsavedChanges = () => {
        this.unsavedChanges = {};
    };

    public deleteUnsavedChanges = (key: UnsavedChanges) => {
        delete (this.unsavedChanges as any)[key];
    };
}
